import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import translate from '../../commonComponents/translate';
import AppProductProp from '../profile/propTypes/appProductProp';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import StripeCardProp from '../profile/propTypes/StripeCardProp';
import CertificateProp from '../academy/propTypes/certificateProp';
import CertificatePreview from './CertificatePreview';
import CertificateLockOverlay from '../../commonComponents/CertificateLockOverlay';

function Certificate({ t, certificate, appProducts, countries, cards }) {
  const handleLockBtn = () => {
    // When a certificate for session is locked since user didn't answer the survey
    if (certificate.survey && certificate.surveyContext) {
      window.location.href = `/survey/${certificate?.survey}?context=${certificate.surveyContext}&backURL=${
        window.location.pathname
      }`;
    }
  };
  return (
    <Title title={t('certificate_head_title')}>
      <ContentContainer>
        <SubHeader title={t('certificate_title')} />
        <div className="m-content">
          <div className="row full-page-container-with-subheader">
            <div className="col-lg-12">
              <div id="certificateLayout" className="m-portlet m-portlet--mobile">
                {certificate.isLocked && (
                  <CertificateLockOverlay
                    message={t('certificate.unlock.message.session')}
                    title={t('certificate.unlock.title')}
                    buttonMessage={t('certificate.unlock.session.button')}
                    onClick={handleLockBtn}
                  />
                )}
                <div className="m-portlet__body">
                  <CertificatePreview
                    certificate={certificate}
                    appProducts={appProducts}
                    countries={countries}
                    cards={cards}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

Certificate.propTypes = {
  t: PropTypes.func.isRequired,
  certificate: PropTypes.shape(CertificateProp.propType).isRequired,
  appProducts: PropTypes.arrayOf(PropTypes.shape(AppProductProp.propType))
    .isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType)).isRequired,
};

export default translate(Certificate);
